import { AxiosResponse } from 'axios'
import ApiService, { IRequestParameters } from '@/plugins/api-plugin/services/api.service'
import JobHistoryLogDao from '@/interfaces/admin/JobHistoryLog.dao'
import { PageNumberPagination } from '@/interfaces/common/PageNumberPagination'

export default class JobHistoryLogsService extends ApiService {
    async getJobHistoryLogs(params?: IRequestParameters): Promise<[JobHistoryLogDao[], PageNumberPagination] | null> {
        return this.request<undefined, [JobHistoryLogDao[], PageNumberPagination] | null>(
            'GET',
            '/job-history-logs',
            params,
            undefined,
            undefined,
            'getJobHistoryLogs',
        ).catch(() => null)
    }

    async getJobHistoryLog(
        id: number,
        params?: IRequestParameters,
    ): Promise<[JobHistoryLogDao[], PageNumberPagination] | null> {
        return this.request<undefined, [JobHistoryLogDao[], PageNumberPagination] | null>(
            'GET',
            `/job-history-logs/${id}`,
            params,
            undefined,
            undefined,
            'getJobHistoryLog',
        ).catch(() => null)
    }

    async exportJobHistoryLogs(): Promise<AxiosResponse | null> {
        return this.request<undefined, AxiosResponse>(
            'GET',
            '/job-history-logs/export',
            undefined,
            undefined,
            'blob',
            'exportJobHistoryLogs',
        ).catch(() => null)
    }

    async exportJobHistoryLog(id: number): Promise<AxiosResponse | null> {
        return this.request<undefined, AxiosResponse>(
            'GET',
            `/job-history-logs/${id}/export`,
            undefined,
            undefined,
            'blob',
            'exportJobHistoryLog',
        ).catch(() => null)
    }
}
